/**
 * Куда вернуться после входа. Экран, закрытый для гостя, отправляет на вход с
 * `?next=<свой путь>`, а вход после успеха ведёт туда, а не на главную. Берём
 * только путь своего приложения: `//host` и `/\host` браузер понял бы как
 * чужой сайт, и ссылка на вход уводила бы покупателя туда.
 */
export const RETURN_PARAM = 'next'

export function loginPath(next: string): string {
  return `/login?${RETURN_PARAM}=${encodeURIComponent(next)}`
}

/** Путь из `?next=`; чужой адрес или его нет — главная. */
export function returnPath(search: string): string {
  const next = new URLSearchParams(search).get(RETURN_PARAM) ?? ''
  return /^\/(?![/\\])/.test(next) ? next : '/'
}
